import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import { Box, Button, Slider, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

type VolumeButtonProps = {
  muted: boolean;
  volume: number;
  toggleMute: () => void;
  changeVolume: (volume: number) => void;
};

export const VolumeButton: FC<VolumeButtonProps> = ({ muted, toggleMute, volume, changeVolume }) => {
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{
        '& .MuiSlider-root': { display: 'none' },
        '&:hover .MuiSlider-root': { display: 'block' },
      }}
      gap="16px"
    >
      <Tooltip title={t(muted ? 'player.controls.unmute' : 'player.controls.mute')} placement="top">
        <Button onClick={toggleMute} color="primary" variant="contained" sx={{ minWidth: '48px' }}>
          {muted ? <VolumeOffIcon /> : <VolumeUpIcon />}
        </Button>
      </Tooltip>
      <Slider
        color="primary"
        value={volume}
        sx={{ width: '130px', marginRight: '20px' }}
        min={0}
        step={0.01}
        max={1}
        onChange={(_, newValue: number | number[]) =>
          changeVolume(Array.isArray(newValue) ? newValue?.[0] ?? 0 : newValue)
        }
      ></Slider>
    </Box>
  );
};
